/* import __COLOCATED_TEMPLATE__ from './editor.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import type AppService from 'embercom/services/app-service';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { BlocksDocument } from '@intercom/composer-ember';
import InternalNotesComposerConfig from 'embercom/lib/internal-notes/composer-config';
import type InternalArticle from 'embercom/models/content-service/internal-article';

interface Args {
  activeContent: InternalArticle;
  defaultThemeColor: string;
  isContentReadinessContext?: boolean;
}

export default class Editor extends Component<Args> {
  @service declare appService: AppService;
  @tracked activeContentBlocksDocument: BlocksDocument;
  @tracked prosemirrorComposer: any;

  constructor(owner: any, args: Args) {
    super(owner, args);
    this.activeContentBlocksDocument = new BlocksDocument(
      this.activeContent.currentVersion?.jsonBlocksForEditor,
    );
  }

  get app() {
    return this.appService.app;
  }

  get activeContent() {
    return this.args.activeContent;
  }

  get prosemirrorComposerConfig() {
    let config = new InternalNotesComposerConfig(this.app, this.activeContent.textDirection);
    config.enableDiffWidget =
      !!this.args.isContentReadinessContext && this.appService.app.canUseContentReadinessScoringUI;
    return config;
  }

  get activeContentBlocks() {
    return new BlocksDocument(this.activeContent.currentVersion?.jsonBlocksForEditor);
  }

  @action
  prosemirrorComposerReady(composer: any) {
    this.prosemirrorComposer = composer;
  }

  @action
  prosemirrorComposerChanged(newBlocksDocument: BlocksDocument) {
    this.activeContentBlocksDocument = newBlocksDocument;
    this.activeContent.newOrCurrentVersion.set('jsonBlocks', newBlocksDocument.blocks);
    this.activeContent.currentVersion?.set('jsonBlocksForEditor', newBlocksDocument.blocks);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::InternalNote::Edit::Editor': typeof Editor;
    'knowledge-hub/content-editor/internal-note/edit/editor': typeof Editor;
  }
}
